/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { ConfirmationTitles, ConfirmationCssClasses } from "../../../../../../../_helpers/Helpers";

export const ConfirmationColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      ConfirmationCssClasses[row.displayOnTheSchoolReport]
    } label-inline`}
  >
    {ConfirmationTitles[row.displayOnTheSchoolReport]}
  </span>
);